import { MOBILE_WIDTH, TABLET_WIDTH } from "helpers/ScreenSizes";

export const EMAIL_BUILDER_PANEL_MUTUAL_EXCLUSION_MAX_WIDTH = 1199;

export function isEmailBuilderMobileViewport(width: number | undefined): boolean {
  return (width ?? MOBILE_WIDTH + 1) <= MOBILE_WIDTH;
}

export function isEmailBuilderCompactShellViewport(width: number | undefined): boolean {
  return (width ?? TABLET_WIDTH + 1) <= TABLET_WIDTH;
}

export function emailBuilderShouldMutuallyExcludePanels(width: number | undefined): boolean {
  return (
    (width ?? EMAIL_BUILDER_PANEL_MUTUAL_EXCLUSION_MAX_WIDTH + 1) <=
    EMAIL_BUILDER_PANEL_MUTUAL_EXCLUSION_MAX_WIDTH
  );
}
